import femaleAvatar from "../assets/avatars/female_avatar.png";
import maleAvatar from "../assets/avatars/male_avatar.png";
import { voices } from "./meetingOptions";

const voiceImages = {
  cedar: maleAvatar,
  marin: femaleAvatar,
};

export const voiceProfiles = voices.map((voice) => ({
  ...voice,
  description: "Natural, professional voice",
  image: voiceImages[voice.value],
}));

const defaultVoiceProfile = voiceProfiles[0];

export function getVoiceProfile(value) {
  return voiceProfiles.find((profile) => profile.value === value) || defaultVoiceProfile;
}
